import React from 'react';
import { SiteContent } from 'components/common/styles';
import ContentLayout from 'components/ContentLayout';
import ScanToShip from 'components/Sales/ScanToShip';
// eslint-disable-next-line
export default () => {
  return (
    <ContentLayout>
      <SiteContent>
        <ScanToShip />
      </SiteContent>
    </ContentLayout>
  );
};
